module.exports = __webpack_public_path__ + "static/media/Espace-client-saham-assurance.e11ad9db.jpg";